import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { StorageService } from '../../../services/storage.service';
import { UserService } from '../../../services/user.service';
import { NotificationService } from '../../../services/notification.service';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-saved-addresses',
  templateUrl: './saved-addresses.component.html',
  styleUrl: './saved-addresses.component.scss',
})
export class SavedAddressesComponent implements OnInit {
  addresses = [];
  addressesLoaded = false;
  editMode: boolean;
  activeIndex: number | null = null;

  toggleActions(i: number) {
    this.activeIndex = this.activeIndex === i ? null : i;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private user: UserService,
    private store: StorageService,
    private http: ApiService,
    private notify: NotificationService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.route.data.subscribe((res) => {
      this.getAlladdress();
    });
  }

  getAlladdress() {
    this.http.get('retailers/myaddress').subscribe((res) => {
      this.addressesLoaded = true;
      console.log(res);
      this.addresses = res.data;
      console.log('yyyyyy', res);
    });
  }

  edit(index, id) {
    // this.registerForm.patchValue({ ...this.addresses[index] });
    // this.editMode = id;
    this.router.navigate([
      '/dashboard/profile/new-address',
      id,
    ]);
  }

  remove(addressId: number) {
    const modalRef = this.modalService.open(ConfirmDialogComponent);
    modalRef.componentInstance.message =
      'You are about to remove this address!';

    modalRef.result.then(
      (confirmed) => {
        if (confirmed) {
          this.http
            .get('retailers/deleteaddress', { params: { addressId } })
            .subscribe((res) => {
              if (res.code === 1) {
                this.getAlladdress();
                this.notify.showSuccess(res.message, '');
              } else {
                this.notify.showError(res.message, '');
              }
            });
        }
      },
      () => {
        // dismissed (cancel)
      }
    );
  }

  select(addressId) {
    this.http
      .get('retailers/setAsDefaultAddress', { params: { addressId } })
      .subscribe((res) => {
        if (res.code == 1) {
          this.notify.showSuccess('Address updated successfully', '');
          this.getAlladdress();
        } else {
          this.notify.showError(res.message, '');
        }
      });
  }

  goBack() {
    this.router.navigate(['/dashboard/home']);
  }

  navigateToNewAddress() {
    this.router.navigate(['/dashboard/profile/new-address']);
  }
}
